import { Route,Routes } from 'react-router-dom';
import CarCompanyTable from '../component/carCompany/carCompanyTable';

const CarCompanyPage = () => {
    return (
        <div>
          
            <Routes>
              <Route path="/"  element={<CarCompanyTable/>}/> 
            </Routes>
            
        </div>
           
    );
}

export default CarCompanyPage;
